export function casesPortalCaseHref(caseId: string, role?: string | null) {
  if ((role || "").toLowerCase() === "user") {
    return `/dashboard/my-cases?case=${encodeURIComponent(caseId)}`;
  }
  return `/dashboard/admin/cases/${encodeURIComponent(caseId)}`;
}

export function smilePortalCaseHref(smileId: string) {
  return `/dashboard/smiledesign/generate/${encodeURIComponent(smileId)}`;
}
